import { render, staticRenderFns } from "./alimtalk.vue?vue&type=template&id=8fea0998"
import script from "./alimtalk.vue?vue&type=script&lang=js"
export * from "./alimtalk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports